<script>
import {IotServerConnections} from '../api.js'

export default {
	mounted: function () {
		this.api.query(IotServerConnections, this.id).updated((result) => {
			this.connections = result;
		})
		this.api.jsonrpc.call('api.v2.servers.get_server', {server_id: this.id}).then((result) => {
			this.server = result
		});
	},
	data: function () {
		return {
			connections: [],
			server: null,
		};
	},
	methods: {
		closeConnection: function(connection_id) {
			this.api.jsonrpc.call('api.v2.connections.close_connection', {'connection_id': connection_id});
		}
	},
	name: "Server",
	props: {
		id: String,
		api: Object,
	}
};
</script>
<template>
<div>
	<div class="row" v-if="server !== null">
		<div class="col m12 small">
			{{server.protocol}} | 
			{{server.url}}
		</div>
	</div>
	<div class="row">
	<h4>Connections</h4>
	<table id="client-table" class="striped">
		<thead>
			<tr>
				<th>Client</th>
				<th>SubProtocol</th>
				<th>Channel Type</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="connection in connections" v-bind:key="connection.id">
				<td>
					<router-link
						v-bind:to="'/servers/' + connection.server_id + '/' + connection.client_id">
						{{ connection.client_id }}
					</router-link>
				</td>
				<td>{{ connection.subprotocol }}</td>
				<td>{{ connection.name || "main" }}</td>
				<td>
					<button class="btn red" v-on:click="closeConnection(connection.id)">Close</button>
				</td>
			</tr>
		</tbody>
	</table>
   </div>
</div>
</template>
